
import '../../../Styles/Styles_estadisticas/dinamicas.css';

const BusquedaSimple = () => {
   
    
};

export default BusquedaSimple;
